function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.initCustomDots();
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
    this.initCustomDots();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    this.updateCustomDots();
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }

  initCustomDots() {
    if (window.innerWidth >= 990) {
      if (this.customDotsContainer) {
        this.customDotsContainer.style.display = 'none';
      }
      return;
    }

    if (!this.customDotsContainer) {
      this.customDotsContainer = document.createElement('div');
      this.customDotsContainer.className = 'zfc-slider__dots';
      this.customDotsContainer.style.justifyContent = 'center';
      this.customDotsContainer.style.marginTop = '15px';
      this.customDotsContainer.style.marginBottom = '15px';
      this.slider.parentNode.insertBefore(this.customDotsContainer, this.slider.nextSibling);
    } else {
      this.customDotsContainer.style.display = 'flex';
    }

    this.renderCustomDots();
  }

  renderCustomDots() {
    if (!this.customDotsContainer) return;
    this.customDotsContainer.innerHTML = '';
    const totalItems = this.sliderItemsToShow.length;
    for (let i = 0; i < totalItems; i++) {
      const dot = document.createElement('span');
      dot.className = 'zfc-dot';
      dot.setAttribute('data-index', i);
      dot.addEventListener('click', () => {
        const targetScroll = i * this.sliderItemOffset;
        this.slider.scrollTo({
          left: targetScroll,
          behavior: 'smooth'
        });
      });
      this.customDotsContainer.appendChild(dot);
    }
    this.updateCustomDots();
  }

  updateCustomDots() {
    if (!this.customDotsContainer) return;
    const dots = this.customDotsContainer.children;
    if (dots.length === 0) return;
    const activeIndex = Math.round(this.slider.scrollLeft / this.sliderItemOffset);
    for (let i = 0; i < dots.length; i++) {
      if (i === activeIndex) {
        dots[i].classList.add('active');
      } else {
        dots[i].classList.remove('active');
      }
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    // Fetch updated price text from the DOM
    const priceItem = document.querySelector(`#price-${this.dataset.section} .price-item--sale`) || document.querySelector(`#price-${this.dataset.section} .price-item--regular`);
    let priceText = priceItem ? priceItem.textContent.trim().replace(/\s+/g, ' ') : '';

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (window.updateAddButtonsPrice) {
        window.updateAddButtonsPrice(this.dataset.section);
      } else {
        addButtonText.textContent = priceText ? `${window.variantStrings.addToCart} - ${priceText}` : window.variantStrings.addToCart;
      }
    }

    // Sync sticky button
    const stickyButton = document.getElementById('ProductSubmitButton-Sticky');
    if (stickyButton) {
      const stickyButtonText = stickyButton.querySelector('span');
      if (stickyButtonText) {
        if (disable) {
          stickyButton.setAttribute('disabled', 'disabled');
          if (text) stickyButtonText.textContent = text;
        } else {
          stickyButton.removeAttribute('disabled');
          if (window.updateAddButtonsPrice) {
            window.updateAddButtonsPrice(this.dataset.section);
          } else {
            stickyButtonText.textContent = priceText ? `${window.variantStrings.addToCart} - ${priceText}` : window.variantStrings.addToCart;
          }
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}



// Shopify Popup Customizer - Shadow DOM Version
(function() {
  if (!document.querySelector('shopify-forms-embed')) return;
  let attempts = 0;
  const maxAttempts = 60; // 30 seconds max wait (60 * 500ms)
  
  function customizePopup() {
    // Find the Shopify Forms embed element
    const embed = document.querySelector('shopify-forms-embed');
    
    // Check if it has shadow DOM
    if (embed && embed.shadowRoot) {
      const shadow = embed.shadowRoot;
      
      // Find the heading using the exact class from your popup
      const heading = shadow.querySelector('._textHeading_2aowh_35');
      
      if (heading) {
        console.log('✓ Popup heading found!');
        
        // Add margin top to heading
        heading.style.marginTop = '24px';
        
        // Check if image already added to avoid duplicates
        if (!shadow.querySelector('.custom-popup-image')) {
          // Find the header container
          const headerContainer = shadow.querySelector('._formHeader_cit2d_24');
          
          if (headerContainer) {
            // Create image element
            const img = document.createElement('img');
            
            // !!! IMPORTANT: REPLACE THIS URL WITH YOUR ACTUAL IMAGE URL !!!
            img.src = 'https://cdn.shopify.com/s/files/1/0780/0786/1441/files/900x900_ZFOLDCASES_LOGO_153417f3-99c9-4af3-8ad1-2586d442769e.png?v=1778687911';
            
            // Style the image
            img.style.width = '64px';
            img.style.height = '64px';
            img.style.margin = '0 auto 16px auto';
            img.style.display = 'block';
            img.style.objectFit = 'contain';
            img.classList.add('custom-popup-image');
            
            // Insert image at the beginning of the header container
            headerContainer.insertBefore(img, headerContainer.firstChild);
            
            console.log('✓ Popup customized successfully! Image added and margin applied.');
            return true;
          } else {
            console.log('Header container not found');
          }
        } else {
          console.log('Image already added');
          return true;
        }
      } else {
        // Try alternative selector if the exact class isn't found
        const altHeading = shadow.querySelector('h2');
        if (altHeading) {
          console.log('Found heading with alternative selector');
          altHeading.style.marginTop = '24px';
          
          if (!shadow.querySelector('.custom-popup-image')) {
            const headerContainer = shadow.querySelector('[class*="Header"]');
            if (headerContainer) {
              const img = document.createElement('img');
              img.src = 'https://cdn.shopify.com/s/files/1/0780/0786/1441/files/900x900_ZFOLDCASES_LOGO_153417f3-99c9-4af3-8ad1-2586d442769e.png?v=1778687911'; // REPLACE THIS
              img.style.width = '80px';
              img.style.height = '80px';
              img.style.margin = '0 auto 16px auto';
              img.style.display = 'block';
              img.classList.add('custom-popup-image');
              headerContainer.insertBefore(img, headerContainer.firstChild);
              console.log('✓ Popup customized with alternative method!');
              return true;
            }
          }
        }
      }
    }
    
    return false;
  }
  
  // Start checking for popup every 500ms
  const interval = setInterval(function() {
    attempts++;
    const success = customizePopup();
    
    if (success) {
      clearInterval(interval);
      console.log('Popup customization complete after', attempts, 'attempts');
    } else if (attempts >= maxAttempts) {
      clearInterval(interval);
      console.log('Popup not found after', maxAttempts, 'attempts');
    }
  }, 500);
})();
customElements.define('product-recommendations', ProductRecommendations);

// ============================================================
// ZFoldCases Accessories Upsell System
// ============================================================
window.updateAddButtonsPrice = function(sectionId) {
  if (!sectionId) {
    const selects = document.querySelector('variant-selects');
    sectionId = selects ? selects.dataset.section : null;
  }
  if (!sectionId) {
    const mainProductSection = document.querySelector('[id^="MainProduct-"]');
    sectionId = mainProductSection ? mainProductSection.id.replace('MainProduct-', '') : null;
  }
  if (!sectionId) return;

  const addButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
  const stickyButton = document.getElementById('ProductSubmitButton-Sticky');
  const stickyButtonText = stickyButton ? stickyButton.querySelector('span') : null;
  
  if (!addButton) return;
  const addButtonText = addButton.querySelector('span');
  if (!addButtonText) return;
  
  // If the main submit button is disabled or sold out, keep the text as is (e.g., Sold out)
  if (addButton.hasAttribute('disabled')) return;
  
  const priceContainer = document.querySelector(`#price-${sectionId}`);
  if (!priceContainer) return;

  // On first run, cache original prices in data attributes so we don't re-read modified DOM
  if (!priceContainer.dataset.originalBasePrice) {
    const priceItem = document.querySelector(`#price-${sectionId} .price-item--sale`) || document.querySelector(`#price-${sectionId} .price-item--regular`);
    if (!priceItem) return;
    let basePriceText = priceItem.textContent.trim().replace(/\s+/g, ' ');
    let digitsOnly = basePriceText.replace(/[^\d.,]/g, '');
    if (digitsOnly.indexOf(',') > -1 && digitsOnly.indexOf('.') === -1) {
      digitsOnly = digitsOnly.replace(',', '.');
    }
    const bp = parseFloat(digitsOnly) || 0;
    priceContainer.dataset.originalBasePrice = bp;

    // Read compare_at_price (true original)
    let op = bp;
    const compareEl = document.querySelector(`#price-${sectionId} .price__sale .price-item--regular`);
    if (compareEl) {
      let compareText = compareEl.textContent.trim().replace(/\s+/g, ' ').replace(/[^\d.,]/g, '');
      if (compareText.indexOf(',') > -1 && compareText.indexOf('.') === -1) {
        compareText = compareText.replace(',', '.');
      }
      const parsed = parseFloat(compareText);
      if (!isNaN(parsed) && parsed > 0) op = parsed;
    }
    if (op === bp) {
      const regEl = document.querySelector(`#price-${sectionId} .price__regular .price-item--regular`);
      if (regEl) {
        let regText = regEl.textContent.trim().replace(/\s+/g, ' ').replace(/[^\d.,]/g, '');
        if (regText.indexOf(',') > -1 && regText.indexOf('.') === -1) {
          regText = regText.replace(',', '.');
        }
        const parsed = parseFloat(regText);
        if (!isNaN(parsed) && parsed > 0) op = parsed;
      }
    }
    priceContainer.dataset.originalComparePrice = op;
  }

  let basePrice = parseFloat(priceContainer.dataset.originalBasePrice) || 0;
  let originalPrice = parseFloat(priceContainer.dataset.originalComparePrice) || basePrice;
  
  // Sum up upsell quantities × prices (applying the active tier discount)
  const upsellInputs = document.querySelectorAll('.zfc-upsell-qty-input');
  let totalUpsellQty = 0;
  upsellInputs.forEach(input => {
    totalUpsellQty += parseInt(input.value) || 0;
  });

  let discountRate = 0;
  if (totalUpsellQty === 1) {
    discountRate = 0.10;
  } else if (totalUpsellQty === 2) {
    discountRate = 0.15;
  } else if (totalUpsellQty >= 3) {
    discountRate = 0.20;
  }

  let upsellsTotal = 0;
  upsellInputs.forEach(input => {
    const qty = parseInt(input.value) || 0;
    if (qty > 0) {
      const card = input.closest('.zfc-upsell-card');
      if (card) {
        let cents = parseInt(card.dataset.price);
        if (!isNaN(cents)) {
          const itemPrice = (cents / 100.0);
          const discountedItemPrice = itemPrice * (1 - discountRate);
          upsellsTotal += discountedItemPrice * qty;
        }
      }
    }
  });
  
  let discountedBasePrice = discountRate > 0 ? basePrice * (1 - discountRate) : basePrice;
  let totalPrice = discountedBasePrice + upsellsTotal;
  let totalPriceInCents = Math.round(totalPrice * 100);
  let formattedPrice = typeof formatMoney === 'function' ? formatMoney(totalPriceInCents, window.moneyFormat) : totalPrice.toFixed(2);
  const baseText = window.variantStrings ? window.variantStrings.addToCart : 'Add to cart';
  addButtonText.textContent = `${baseText} - ${formattedPrice}`;
  if (stickyButtonText) {
    stickyButtonText.textContent = `${baseText} - ${formattedPrice}`;
  }

  // Update the displayed product price (show discounted price + original barré on the right)
  if (priceContainer) {
    const priceDiv = priceContainer.querySelector('.price');
    if (priceDiv) {
      if (discountRate > 0) {
        // Show sale layout
        priceDiv.classList.add('price--on-sale');
        const regularDiv = priceDiv.querySelector('.price__regular');
        const saleDiv = priceDiv.querySelector('.price__sale');
        if (regularDiv) regularDiv.style.display = 'none';
        if (saleDiv) {
          saleDiv.style.display = '';
          const originalPriceInCents = Math.round(originalPrice * 100);
          const discountedBasePriceInCents = Math.round(discountedBasePrice * 100);
          const formattedOriginal = typeof formatMoney === 'function' ? formatMoney(originalPriceInCents, window.moneyFormat) : originalPrice.toFixed(2);
          const formattedDiscounted = typeof formatMoney === 'function' ? formatMoney(discountedBasePriceInCents, window.moneyFormat) : discountedBasePrice.toFixed(2);
          const strikeEl = saleDiv.querySelector('.price-item--regular');
          const saleEl = saleDiv.querySelector('.price-item--sale, .price-item--last');
          if (strikeEl) strikeEl.textContent = formattedOriginal;
          if (saleEl) saleEl.textContent = formattedDiscounted;
          // Move barré price after sale price
          if (strikeEl && saleEl) {
            const strikeParent = strikeEl.closest('span') || strikeEl;
            saleDiv.appendChild(strikeParent);
          }
        }
        // Update % OFF badge inline after barré
        const badge = priceDiv.querySelector('.price__badge-sale');
        if (badge) {
          const pct = originalPrice > 0 ? Math.round(((originalPrice - discountedBasePrice) / originalPrice) * 100) : Math.round(discountRate * 100);
          badge.textContent = `${pct}% OFF`;
          badge.style.display = '';
          const saleDiv2 = priceDiv.querySelector('.price__sale');
          if (saleDiv2) saleDiv2.appendChild(badge);
        }
      } else {
        // Restore original layout
        priceDiv.classList.remove('price--on-sale');
        const regularDiv = priceDiv.querySelector('.price__regular');
        const saleDiv = priceDiv.querySelector('.price__sale');
        if (regularDiv) regularDiv.style.display = '';
        if (saleDiv) saleDiv.style.display = '';
        // Hide badge
        const badge = priceDiv.querySelector('.price__badge-sale');
        if (badge) badge.style.display = 'none';
      }
    }
  }
};

// Global formatMoney helper for Shopify stores
window.formatMoney = function(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || window.moneyFormat || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision === undefined ? 2 : precision;
    thousands = thousands === undefined ? ',' : thousands;
    decimal = decimal === undefined ? '.' : decimal;

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  const match = formatString.match(placeholderRegex);
  if (!match) {
    return (cents / 100).toFixed(2);
  }

  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// ═══════ ZFC Tiered Upsell Widget ═══════
document.addEventListener('DOMContentLoaded', () => {
  const TIERS = [
    { min: 1, discount: 10, label: 'Save 10%' },
    { min: 2, discount: 15, label: 'Save 15%' },
    { min: 3, discount: 20, label: 'Save 20%' },
  ];

  function getTotalUpsellQty() {
    let total = 0;
    document.querySelectorAll('.zfc-upsell-qty-input').forEach(input => {
      total += parseInt(input.value) || 0;
    });
    return total;
  }

  function getCurrentTier(qty) {
    let tier = null;
    for (let i = TIERS.length - 1; i >= 0; i--) {
      if (qty >= TIERS[i].min) { tier = TIERS[i]; break; }
    }
    return tier;
  }

  function getNextTier(qty) {
    for (const t of TIERS) {
      if (qty < t.min) return t;
    }
    return null;
  }

  function formatPrice(cents) {
    return window.formatMoney(cents, window.moneyFormat);
  }

  function updateTierUI() {
    const qty = getTotalUpsellQty();
    const currentTier = getCurrentTier(qty);
    const nextTier = getNextTier(qty);
    const widget = document.getElementById('zfc-upsells-widget');
    if (!widget) return;

    const container = document.querySelector('.zfc-upsells-container');
    if (container) {
      container.classList.toggle('offer-active', qty > 0);
    }

    // Update title
    const titleEl = document.getElementById('zfc-offer-title');
    if (titleEl) {
      if (qty === 0) {
        titleEl.innerHTML = `Buy More, Save More`;
      } else if (qty === 1) {
        titleEl.innerHTML = `<span class="zfc-title-highlight">10% OFF</span> Unlocked!`;
      } else if (qty === 2) {
        titleEl.innerHTML = `<span class="zfc-title-highlight">15% OFF</span> Unlocked!`;
      } else if (qty >= 3) {
        titleEl.innerHTML = `🎉 Max <span class="zfc-title-highlight">20% OFF</span> Unlocked!`;
      }
    }

    // Update message
    const msgEl = document.getElementById('zfc-offer-msg');
    if (msgEl) {
      if (qty === 0) {
        msgEl.innerHTML = `Add accessories to unlock up to <strong class="zfc-offer-saved">20% OFF</strong>`;
      } else if (qty === 1) {
        msgEl.innerHTML = `Add <strong class="zfc-offer-remaining">1 more</strong> accessory to get <strong class="zfc-offer-saved">15% OFF</strong>`;
      } else if (qty === 2) {
        msgEl.innerHTML = `Add <strong class="zfc-offer-remaining">1 more</strong> accessory to get <strong class="zfc-offer-saved">20% OFF</strong>`;
      } else if (qty >= 3) {
        msgEl.innerHTML = `<strong class="zfc-offer-saved">20% discount</strong> automatically applied to all accessories!`;
      }
    }

    // Update tier tabs
    const tierEls = document.querySelectorAll('.zfc-tier[data-tier]');
    tierEls.forEach((el, i) => {
      el.classList.remove('active', 'reached');
      const tierData = TIERS[i];
      if (!tierData) return;
      if (qty >= tierData.min) {
        el.classList.add('reached');
        const isHighest = !TIERS[i + 1] || qty < TIERS[i + 1].min;
        if (isHighest) el.classList.add('active');
      }
    });

    // Update progress bar — smooth stepped progress
    const fillEl = document.getElementById('zfc-progress-bar-fill-element');
    if (fillEl) {
      let progress = 5; // Start at 5% when 0 items added so the bar has a small visible start
      if (qty >= 3) {
        progress = 100;
      } else if (qty > 0) {
        // Linear mapping across the 3 segments:
        // Segment 1 (0 -> 1): 0% to 33.3%
        // Segment 2 (1 -> 2): 33.3% to 66.6%
        // Segment 3 (2 -> 3): 66.6% to 100%
        if (qty === 1) {
          progress = 33.3;
        } else if (qty === 2) {
          progress = 66.6;
        }
      }
      fillEl.style.setProperty('width', Math.min(progress, 100) + '%', 'important');
    }



    // Toggle offer-unlocked class
    widget.classList.toggle('offer-unlocked', !!currentTier);

    // Update card selected states & discount prices
    document.querySelectorAll('.zfc-upsell-card').forEach(card => {
      const input = card.querySelector('.zfc-upsell-qty-input');
      const val = parseInt(input?.value) || 0;
      card.classList.toggle('selected', val > 0);

      const qtyDisplay = card.querySelector('.zfc-qty-display');
      const decBtn = card.querySelector('.zfc-qty-adjust.decrease');
      const qtyPicker = card.querySelector('.zfc-upsell-qty-picker');

      if (qtyDisplay) {
        qtyDisplay.textContent = val;
        if (val > 0) {
          qtyDisplay.style.color = '#1d1d1f';
          if (decBtn) {
            decBtn.style.color = '#1d1d1f';
            decBtn.style.pointerEvents = 'auto';
          }
          if (qtyPicker) qtyPicker.classList.add('active-picker');
        } else {
          qtyDisplay.style.color = '#86868b';
          if (decBtn) {
            decBtn.style.color = '#d2d2d7';
            decBtn.style.pointerEvents = 'none';
          }
          if (qtyPicker) qtyPicker.classList.remove('active-picker');
        }
      }

      // Show discounted price per card
      const priceEl = card.querySelector('.zfc-upsell-card-price');
      const originalPriceEl = card.querySelector('.zfc-upsell-card-original-price');
      const priceCents = parseInt(card.dataset.price) || 0;

      if (priceEl && val > 0 && currentTier) {
        const discountedCents = Math.round(priceCents * (1 - currentTier.discount / 100));
        priceEl.textContent = formatPrice(discountedCents);
        priceEl.classList.add('discounted');
        if (originalPriceEl) {
          originalPriceEl.textContent = formatPrice(priceCents);
          originalPriceEl.style.display = 'inline';
        }
      } else if (priceEl) {
        priceEl.textContent = formatPrice(priceCents);
        priceEl.classList.remove('discounted');
        if (originalPriceEl) {
          originalPriceEl.style.display = 'none';
        }
      }
    });

    // Update savings total badge (hidden as requested)
    const savingsBadge = document.getElementById('zfc-savings-badge');
    if (savingsBadge) {
      savingsBadge.style.display = 'none';
    }

    // Update Add to Cart button price
    if (typeof window.updateAddButtonsPrice === 'function') {
      window.updateAddButtonsPrice();
    }

  }

  // Handle card clicks to toggle selection or adjust quantity
  document.addEventListener('click', (e) => {
    // 0. Check if click is on the "Add" button
    const addBtn = e.target.closest('.zfc-upsell-add-btn');
    if (addBtn) {
      const card = addBtn.closest('.zfc-upsell-card');
      if (!card) return;
      const input = card.querySelector('.zfc-upsell-qty-input');
      const picker = card.querySelector('.zfc-upsell-qty-picker');
      if (!input || !picker) return;

      input.value = 1;
      addBtn.style.display = 'none';
      picker.style.display = 'flex';
      updateTierUI();
      return;
    }

    // 1. Check if click is on a quantity vertical adjuster button
    const qtyBtn = e.target.closest('.zfc-qty-adjust');
    if (qtyBtn) {
      const card = qtyBtn.closest('.zfc-upsell-card');
      if (!card) return;
      const input = card.querySelector('.zfc-upsell-qty-input');
      if (!input) return;

      let val = parseInt(input.value) || 0;
      if (qtyBtn.dataset.action === 'increase') {
        val = Math.min(val + 1, 10);
      } else if (qtyBtn.dataset.action === 'decrease') {
        val = Math.max(val - 1, 0);
      }
      input.value = val;

      // If qty goes to 0, swap back to Add button
      if (val === 0) {
        const addBtn = card.querySelector('.zfc-upsell-add-btn');
        const picker = card.querySelector('.zfc-upsell-qty-picker');
        if (addBtn && picker) {
          picker.style.display = 'none';
          addBtn.style.display = '';
        }
      }

      updateTierUI();
      return;
    }

    // 2. Check if click is inside the picker or variant dropdown container
    if (e.target.closest('.zfc-upsell-qty-picker') || e.target.closest('.zfc-upsell-variant-select') || e.target.closest('.zfc-upsell-variant-wrapper')) {
      return;
    }
  });

  // Handle variant select dropdown changes (Product Page & Cart Drawer)
  document.addEventListener('change', (e) => {
    // 1. Product Page Upsells
    const select = e.target.closest('.zfc-upsell-variant-select');
    if (select) {
      const card = select.closest('.zfc-upsell-card');
      if (!card) return;
      const opt = select.options[select.selectedIndex];
      if (!opt) return;

      const variantId = opt.value;
      const price = opt.dataset.price;
      const priceRaw = opt.dataset.priceRaw;
      const imageSrc = opt.dataset.imageSrc;

      card.dataset.variantId = variantId;
      if (priceRaw) card.dataset.price = priceRaw;

      const img = card.querySelector('.zfc-upsell-card-media img');
      if (img && imageSrc) {
        img.src = imageSrc;
        img.removeAttribute('srcset');
      }

      const priceEl = card.querySelector('.zfc-upsell-card-price');
      if (priceEl && price) priceEl.textContent = price;

      const addBtn = card.querySelector('.zfc-upsell-add-btn');
      if (addBtn) addBtn.dataset.variantId = variantId;

      const input = card.querySelector('.zfc-upsell-qty-input');
      if (input) {
        input.dataset.variantId = variantId;
        input.id = 'upsell-qty-' + variantId;
        input.value = 0;
      }

      const picker = card.querySelector('.zfc-upsell-qty-picker');
      const valDisplay = card.querySelector('.zfc-upsell-qty-val');
      if (valDisplay) valDisplay.textContent = '0';
      if (addBtn && picker) {
        picker.style.display = 'none';
        addBtn.style.display = '';
      }

      updateTierUI();
      return;
    }

    // 2. Cart Drawer Upsells
    const drawerSelect = e.target.closest('.zfc-drawer-upsell-variant-select');
    if (drawerSelect) {
      const card = drawerSelect.closest('.zfc-drawer-upsell-carousel-card');
      if (!card) return;
      const opt = drawerSelect.options[drawerSelect.selectedIndex];
      if (!opt) return;

      const variantId = opt.value;
      const price = opt.dataset.price;
      const imageSrc = opt.dataset.imageSrc;
      const inCart = opt.dataset.inCart === 'true';
      const cartQty = opt.dataset.cartQty || '0';

      card.dataset.variantId = variantId;

      const img = card.querySelector('.zfc-drawer-upsell-carousel-card-media img');
      if (img && imageSrc) {
        img.src = imageSrc;
        img.removeAttribute('srcset');
      }

      const priceEl = card.querySelector('.zfc-drawer-upsell-carousel-card-price');
      if (priceEl && price) priceEl.textContent = price;

      const addBtn = card.querySelector('.zfc-drawer-upsell-carousel-add-btn');
      const qtyWrapper = card.querySelector('.zfc-drawer-upsell-qty');
      const qtyVal = card.querySelector('.zfc-drawer-upsell-qty-value');

      if (addBtn) addBtn.dataset.variantId = variantId;
      if (qtyWrapper) qtyWrapper.dataset.variantId = variantId;
      if (qtyVal) qtyVal.textContent = cartQty;

      if (inCart) {
        if (addBtn) addBtn.style.display = 'none';
        if (qtyWrapper) qtyWrapper.style.display = 'inline-flex';
      } else {
        if (addBtn) {
          addBtn.style.display = '';
          addBtn.removeAttribute('disabled');
          addBtn.classList.remove('loading');
        }
        if (qtyWrapper) qtyWrapper.style.display = 'none';
      }
    }
  });

  // Initial render
  updateTierUI();
});

// Intercept form submissions for AJAX cart drawer updates (with upsell support)
document.addEventListener('submit', (e) => {
  try {
    const form = e.target;
    const formId = form.getAttribute('id') || '';
    const isProductForm = form && (
      formId.includes('product-form') ||
      (form.getAttribute('data-type') === 'add-to-cart-form') ||
      form.closest('product-form')
    );
    if (!isProductForm) return;

    // Check if any upsell quantities are > 0
    const upsellInputs = form.querySelectorAll('.zfc-upsell-qty-input');
    let hasUpsells = false;
    upsellInputs.forEach(input => { if (parseInt(input.value) > 0) hasUpsells = true; });
    if (!hasUpsells) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const productForm = form.closest('product-form') || document.querySelector('product-form');
    if (!productForm) return;

    const submitButton = productForm.querySelector('[type="submit"]') || document.getElementById('ProductSubmitButton-Sticky');
    if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
    }
    const spinner = productForm.querySelector('.loading__spinner') || (submitButton ? submitButton.querySelector('.loading__spinner') : null);
    if (spinner) spinner.classList.remove('hidden');

    const mainVariantInput = form.querySelector('[name="id"]');
    if (!mainVariantInput) {
      if (submitButton) { submitButton.classList.remove('loading'); submitButton.removeAttribute('aria-disabled'); }
      if (spinner) spinner.classList.add('hidden');
      return;
    }
    const mainVariantId = mainVariantInput.value;
    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    const items = [{ id: parseInt(mainVariantId), quantity: quantity }];
    upsellInputs.forEach((input) => {
      const qty = parseInt(input.value) || 0;
      if (qty > 0) {
        items.push({ id: parseInt(input.dataset.variantId), quantity: qty });
      }
    });

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    // Step 1: Add items to cart via JSON
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          const errorMessage = productForm.querySelector('.product-form__error-message');
          if (errorMessage) {
            errorMessage.textContent = response.description;
            const wrapper = productForm.querySelector('.product-form__error-message-wrapper');
            if (wrapper) wrapper.removeAttribute('hidden');
          }
          return;
        }
        if (!cart) {
          window.location = '/cart';
          return;
        }

        return Promise.all([
          fetch(`${routes.cart_url}?section_id=cart-drawer&sections_url=${encodeURIComponent(window.location.pathname)}`).then(r => r.text()),
          fetch(`${routes.cart_url}?section_id=cart-icon-bubble`).then(r => r.text()),
        ]);
      })
      .then((sections) => {
        if (!sections || !cart) return;
        const [drawerHTML, bubbleHTML] = sections;

        const drawerParsed = new DOMParser().parseFromString(drawerHTML, 'text/html');
        const newDrawer = drawerParsed.querySelector('#CartDrawer');
        const currentDrawer = document.getElementById('CartDrawer');
        if (newDrawer && currentDrawer) currentDrawer.innerHTML = newDrawer.innerHTML;

        const bubbleParsed = new DOMParser().parseFromString(bubbleHTML, 'text/html');
        const newBubble = bubbleParsed.querySelector('.shopify-section');
        const currentBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;

        cart.classList.remove('is-empty');
        const inner = cart.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');

        const overlay = cart.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', () => cart.close());
        cart.open();

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: mainVariantId }); } catch (err) {}
        }
      })
      .catch((err) => {
        console.error('Cart add fetch failed:', err);
      })
      .finally(() => {
        if (submitButton) { submitButton.classList.remove('loading'); submitButton.removeAttribute('aria-disabled'); }
        if (spinner) spinner.classList.add('hidden');
      });
  } catch (globalErr) {
    console.error('Global submit interceptor error:', globalErr);
  }
}, { capture: true });

// Cart Drawer Slider Navigation
document.addEventListener('click', (e) => {
  const navArrow = e.target.closest('.zfc-nav-arrow');
  if (navArrow) {
    const slider = navArrow.closest('.zfc-drawer-recommendations').querySelector('.zfc-drawer-recommendations-slider');
    if (slider) {
      const scrollAmount = 162; // card width (150px) + gap (12px)
      if (navArrow.classList.contains('prev')) {
        slider.scrollLeft -= scrollAmount;
      } else {
        slider.scrollLeft += scrollAmount;
      }
    }
  }
});

// Cart Drawer Accessories Upsell Carousel direct Add button click handler
document.addEventListener('click', (e) => {
  const addBtn = e.target.closest('.zfc-drawer-upsell-carousel-add-btn');
  if (addBtn) {
    const variantId = addBtn.dataset.variantId;
    if (!variantId) return;
    
    addBtn.classList.add('loading');
    addBtn.setAttribute('disabled', 'disabled');
    
    const formData = new FormData();
    formData.append('items[0][id]', variantId);
    formData.append('items[0][quantity]', '1');
    
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    
    if (cart) {
      const sectionsToRender = cart.getSectionsToRender().map(section => section.id).join(',');
      formData.append('sections', sectionsToRender);
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }
    
    config.body = formData;
    
    const cartAddUrl = window.routes ? window.routes.cart_add_url : '/cart/add';
    fetch(cartAddUrl, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          alert('Failed to add accessory: ' + response.description);
          return;
        }
        
        if (window.publish && window.PUB_SUB_EVENTS) {
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              cartData: response,
            });
          } catch (pubErr) {
            console.error('Pubsub event failed:', pubErr);
          }
        }
        
        if (cart) {
          cart.renderContents(response);
        } else {
          window.location.reload();
        }
      })
      .catch((err) => {
        alert('Upsell add to cart failed: ' + err.message);
      })
      .finally(() => {
        addBtn.classList.remove('loading');
        addBtn.removeAttribute('disabled');
      });
  }

  /* Qty +/- buttons */
  const qtyBtn = e.target.closest('.zfc-drawer-upsell-qty-btn');
  if (qtyBtn) {
    const qtyWrap = qtyBtn.closest('.zfc-drawer-upsell-qty');
    const variantId = qtyWrap.dataset.variantId;
    const qtySpan = qtyWrap.querySelector('.zfc-drawer-upsell-qty-value');
    let qty = parseInt(qtySpan.textContent) || 1;

    if (qtyBtn.classList.contains('zfc-qty-plus')) {
      qty++;
    } else if (qtyBtn.classList.contains('zfc-qty-minus')) {
      qty--;
    }

    if (qty < 0) qty = 0;

    qtyBtn.setAttribute('disabled', 'disabled');

    const cartChangeUrl = window.routes ? window.routes.cart_change_url : '/cart/change.js';
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const body = JSON.stringify({ id: variantId, quantity: qty, sections: cart ? cart.getSectionsToRender().map(s => s.id).join(',') : '', sections_url: window.location.pathname });

    fetch(cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then(r => r.json())
      .then(response => {
        if (window.publish && window.PUB_SUB_EVENTS) {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: response }); } catch(e) {}
        }
        if (cart) {
          cart.renderContents(response);
        } else {
          window.location.reload();
        }
      })
      .catch(err => console.error('Qty change failed:', err))
      .finally(() => qtyBtn.removeAttribute('disabled'));
  }
});

// High-Performance Delegated Event Listener for Product Swatches
document.addEventListener('click', function(e) {
  var swatch = e.target.closest('.card-swatch');
  if (!swatch) return;
  e.preventDefault();
  e.stopPropagation();

  var card = swatch.closest('.product-card-wrapper');
  if (!card) return;

  var cardSwatches = card.querySelectorAll('.card-swatch');
  cardSwatches.forEach(function(s) { s.classList.remove('active'); });
  swatch.classList.add('active');

  var mainImages = card.querySelectorAll('.card__media img');
  var links = card.querySelectorAll('a.full-unstyled-link, .card__inner > a');
  var colorLabel = card.querySelector('.card-swatch-label');
  var priceContainer = card.querySelector('.price');

  var newImgSrc = swatch.getAttribute('data-image-src');
  if (newImgSrc && mainImages.length > 0) {
    mainImages.forEach(function(img) {
      img.src = newImgSrc;
      img.srcset = newImgSrc;
    });
  }

  var newUrl = swatch.getAttribute('data-product-url');
  if (newUrl) {
    links.forEach(function(link) {
      link.setAttribute('href', newUrl);
    });
  }

  var newColorName = swatch.getAttribute('data-color-name');
  if (newColorName && colorLabel) {
    colorLabel.textContent = newColorName;
  }

  var newPrice = swatch.getAttribute('data-price');
  if (newPrice && priceContainer) {
    var priceItem = priceContainer.querySelector('.price-item--regular .price-item__price, .price-item--regular, .price-item');
    if (priceItem) {
      priceItem.textContent = newPrice;
    }
  }

  var newVariantId = swatch.getAttribute('data-variant-id');
  if (newVariantId) {
    card.querySelectorAll('.product-variant-id').forEach(function(input) {
      input.value = newVariantId;
    });
  }

  var isAvailable = swatch.getAttribute('data-available') === 'true';
  var quickAddBtn = card.querySelector('.card-image-quick-add__btn');
  if (quickAddBtn) {
    if (isAvailable) {
      quickAddBtn.removeAttribute('disabled');
    } else {
      quickAddBtn.setAttribute('disabled', 'true');
    }
  }
});


